import { RouteInfo } from "@tr/models"

export const testerProfileLinks: RouteInfo[] = [
]

export const testerLinks: RouteInfo[] = [
  {
    path: "/tester/dashboard",
    title: "Dashboard",
    icon: "ti-panel",
  },
]
